const enMessages = {
"main.name": "Nama",
  "main.sentiment": "Sentimen",
  "main.urgency": "Urgensi",
  "main.language": "Bahasa",
  "main.agent": "Agen",
  "main.property_name": "Nama properti",
  "main.booking_number": "Nomor pemesanan",
  "main.check_out": "Check Out",
  "main.check_in": "Check In",
  "main.adults": "Dewasa",
  "main.corporate_code": "Kode perusahaan",
  "main.group_code": "Kode grup",
  "main.promo_code": "Kode promo",
  "main.ai_response": "Respons AI",
  "main.template_response": "Respons template",
  "main.converttoticket": "Konversi ke tiket",
  "main.switch_property": "Ganti properti",
  "main.Group_id": "ID Grup",
  "main.integration_id": "ID Integrasi",
  "main.submit": "Kirim",
  "main.cancel": "Batal",
    "main.select_template": "Pilih Template",
  "main.rooms": "Kamar",
  "main.rates": "Harga",

  //footer
  "footer.knowledge": "Pengetahuan",
  "footer.home": "Beranda",
  "footer.help": "Bantuan",

  //ticket
  "ticket.thank_you": "Terima kasih telah mengirimkan formulir",
  "ticket.ticket": "Tiket",
  "ticket.details": "Silakan isi formulir yang menjelaskan detail tiket.",
  "ticket.select_category": "Pilih Kategori",
  "ticket.category": "Kategori",
  "ticket.title": "Judul",
  "ticket.notes": "Catatan",
  "ticket.status": "Status",
  "ticket.assigned_to": "Ditugaskan Kepada",
  "ticket.submit_form": "Kirim Formulir",
  
  
  "main.total": "Total",
  "main.pastetooutlook": "Tempel ke Outlook",
  "main.children": "Anak-anak",
  "main.promocode": "Kode Promo/Perusahaan/Kelompok",
  "main.exact_match_only": "Hanya Cocok Tepat",
  "main.search": "Cari",
  "main.no_rate_match": "Tidak ada tarif yang cocok dengan pilihan Anda. Silakan ubah pencarian dan coba lagi.",
  "main.translate_to": "Terjemahkan ke",
  "main.regenerate": "Buat Ulang",
  "main.copy_text": "Salin Teks",
  "main.additional_instructions": "Instruksi Tambahan",

  "faq.helpcenter": "Pusat Bantuan",
  "faq.reply.email.sabre.question": "Bagaimana cara membalas email menggunakan Aven Hospitality Concierge Email Automation?",
  "faq.reply.email.sabre.answer": "Buka email dan jalankan add-in Aven Hospitality. Anda dapat memilih tiga opsi: menggunakan template yang telah ditentukan, membuat respons AI, atau mengubah email menjadi tiket. Pilih opsi yang sesuai, tinjau respons, lakukan perubahan jika diperlukan, lalu kirim langsung dari Outlook.",

  "faq.rates.availability.question": "Bagaimana cara menambahkan tarif, ketersediaan, dan detail kamar ke respons saya?",
  "faq.rates.availability.answer": "Gunakan fitur + Rates untuk memasukkan detail tamu seperti tanggal dan jumlah tamu. Concierge akan memasukkan ketersediaan dan harga yang akurat ke dalam balasan Anda. Anda juga dapat menggunakan + Rooms untuk menambahkan deskripsi kamar dan gambar.",

  "faq.different.language.question": "Apa yang harus saya lakukan jika email menggunakan bahasa yang berbeda?",
  "faq.different.language.answer": "Aven Hospitality Concierge memungkinkan Anda menerjemahkan email masuk ke bahasa pilihan Anda.",

  "faq.pin.addin.question": "Bagaimana memastikan add-in selalu tersedia di Outlook?",
  "faq.pin.addin.answer": "Sematkan add-in Aven Hospitality Concierge di Outlook agar selalu terlihat dan terbuka otomatis.",

  "faq.knowledge.hub.question": "Apa itu opsi pencarian Knowledge Hub?",
  "faq.knowledge.hub.answer": "Pencarian Knowledge Hub membantu menemukan informasi properti langsung di Outlook.",

  "faq.reply.email.myma.question": "Bagaimana cara membalas email menggunakan Myma?",
  "faq.reply.email.myma.answer": "Buka email dan jalankan add-in Myma. Anda dapat menggunakan template, membuat respons AI, atau mengubah email menjadi tiket.",

  "faq.room.details.question": "Bagaimana cara menambahkan detail kamar ke respons saya?",
  "faq.room.details.answer": "Gunakan + Rooms untuk menyertakan deskripsi kamar dan gambar.",

  "faq.myma.different.language.question": "Apa yang harus saya lakukan jika email menggunakan bahasa berbeda?",
  "faq.myma.different.language.answer": "Myma memungkinkan Anda menerjemahkan email masuk ke bahasa pilihan Anda sebelum mengirim respons.",

  "faq.myma.pin.addin.question": "Bagaimana memastikan add-in selalu tersedia di Outlook?",
  "faq.myma.pin.addin.answer": "Sematkan add-in Myma di Outlook agar terbuka otomatis dengan setiap email."


};
export default enMessages;